import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/api/members/login',
    method: 'post',
    params: {
      mobile: username,
      code: password
    }
  })
}

export function getsmscode(mobile) {
  var data = {
    mobile: mobile
  }
  return request({
    url: '/api/members/get-code',
    method: 'post',
    params: data
  })
}

export function search(keyword) {
  var data = {
    keyword: keyword
  }
  return request({
    url: '/api/members/search',
    method: 'get',
    params: data
  })
}
export function all() {
  return request({
    url: '/api/members/all',
    method: 'get'
  })
}

